// js/ui/Hud.js
// 遊戲中 HUD：體力、路線預算、目標清單、打卡倒數、提示與動作按鈕。

export class Hud {
  constructor(root) {
    this.root = root;
    this.el = document.createElement('div');
    this.el.className = 'hud hidden';
    this.el.innerHTML = `
      <div class="hud-chip"><span class="label">體力</span><div class="meter" id="hud-dur"><i style="width:100%"></i></div></div>
      <div class="hud-chip"><span class="label">路線</span><div class="meter" id="hud-route"><i style="width:0%"></i></div><span id="hud-route-txt" style="min-width:46px">0/0</span></div>
      <div class="hud-chip" id="hud-time-chip"><span class="label">打卡倒數</span><div class="meter time" id="hud-time-meter"><i style="width:100%"></i></div><span id="hud-time">0.0</span></div>div>
      <div class="hud-goals" id="hud-goals"></div>
      <div class="hud-actions">
        <button class="btn secondary" id="hud-clear">重畫</button>
        <button class="btn secondary" id="hud-menu">返回</button>
      </div>
      <div class="hud-hint" id="hud-hint"></div>
    `;
    this.root.appendChild(this.el);
    this._cache();
  }

  _cache() {
    this.dur = this.el.querySelector('#hud-dur');
    this.route = this.el.querySelector('#hud-route');
    this.routeTxt = this.el.querySelector('#hud-route-txt');
    this.time = this.el.querySelector('#hud-time');
    this.timeChip = this.el.querySelector('#hud-time-chip');
    this.timeMeter = this.el.querySelector('#hud-time-meter');
    this.goals = this.el.querySelector('#hud-goals');
    this.hint = this.el.querySelector('#hud-hint');
    this.clearBtn = this.el.querySelector('#hud-clear');
    this.menuBtn = this.el.querySelector('#hud-menu');
  }

  onClear(fn) { this.clearBtn.onclick = fn; }
  onMenu(fn) { this.menuBtn.onclick = fn; }

  show() { this.el.classList.remove('hidden'); }
  hide() { this.el.classList.add('hidden'); }

  setHint(t) { this.hint.textContent = t || ''; }
  setHintVisible(v) { this.hint.style.display = v ? '' : 'none'; }

  // goals: [{text, met}]; maxLen: number; used: number
  setGoals(goals, maxLen) {
    this.goals.innerHTML = goals.map((g) =>
      `<div class="row ${g.met ? 'done' : ''}"><span class="box"></span><span>${g.text}</span></div>`
    ).join('');
  }

  update({ durability, maxDurability, routeUsed, routeMax, time, timeLimit, collectCount, collectTotal, collisions, delivered, failed }) {
    const dPct = Math.max(0, Math.min(100, (durability / maxDurability) * 100));
    this.dur.querySelector('i').style.width = dPct + '%';
    this.dur.classList.toggle('warn', dPct <= 50 && dPct > 25);
    this.dur.classList.toggle('bad', dPct <= 25);

    const rPct = routeMax ? Math.min(100, (routeUsed / routeMax) * 100) : 0;
    this.route.querySelector('i').style.width = rPct + '%';
    this.routeTxt.textContent = `${routeUsed.toFixed(1)}/${routeMax}`;
    // 打卡倒數：進度條＋剩餘秒數；少於限時 3 成或 10 秒轉紅警示
    const lim = timeLimit || 30;
    this.time.textContent = time.toFixed(1);
    this.timeMeter.querySelector('i').style.width = Math.max(0, (time / lim) * 100) + '%';
    const danger = time <= 10 || time <= lim * 0.3;
    this.timeMeter.classList.toggle('warn', !danger && time <= lim * 0.6);
    this.timeMeter.classList.toggle('bad', danger);
    this.timeChip.classList.toggle('danger', danger);
  }
}
